import { render, staticRenderFns } from "./ATextAreaField.vue?vue&type=template&id=f9d162a0&"
import script from "./ATextAreaField.vue?vue&type=script&lang=js&"
export * from "./ATextAreaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports